'use client';

import { usePathname } from 'next/navigation';
import type { PropsWithChildren } from 'react';
import { useEffect } from 'react';

export default function ScrollToTop({ children }: PropsWithChildren) {
	const pathname = usePathname();

	useEffect(() => {
		if (pathname !== '/insurance') {
			window.scrollTo(0, 0);
		}
	}, [pathname]);

	return <>{children}</>;
}
